import { FC } from 'react';
import { Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const CreateJiraTicketFooter: FC<
  React.PropsWithChildren<CreateJiraTicketFooterProps>
> = ({ onClose, onSubmit, loadingSubmit, classNames = [], loadingDialog, disableSubmit }) => {
  return (
    <div className={classNames.join(' ')}>
      <Button color='secondary' onClick={onClose} variant='outlined'>
        <Typography color='text.secondary' variant='body1' component='span'>
          Cancel
        </Typography>
      </Button>
      <LoadingButton
        disabled={disableSubmit || loadingDialog}
        color='primary'
        onClick={onSubmit}
        loading={loadingSubmit}
        variant='contained'>
        <Typography color='inherit' variant='body1' component='span'>
          Submit
        </Typography>
      </LoadingButton>
    </div>
  );
};

export interface CreateJiraTicketFooterProps {
  onClose: () => void;
  onSubmit: () => void;
  loadingSubmit: boolean;
  loadingDialog: boolean;
  classNames?: string[];
  disableSubmit:boolean

}

export default CreateJiraTicketFooter;
